module.exports = __webpack_public_path__ + "img/php.6238b3cf.svg";